
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25.219 26.121"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M24.835 23.792l-6.219-6.466a10.542 10.542 0 10-8.072 3.766 10.433 10.433 0 006.042-1.908l6.266 6.516a1.376 1.376 0 101.983-1.907zM10.546 2.751a7.8 7.8 0 11-7.8 7.8 7.8 7.8 0 017.8-7.8z"}})])
          )
        }
      }
    